import { WebApiService } from './plugins/webApiService';
import FileS3Service from './files/service/FileS3Service';
import LogsAnalysisService from './logs/analysis/service/LogsAnalysisService';
import ServiceTelegramApi from './projects/telegram-api/service/ServiceTelegramApi';
import NotificationsService from './notifications/service/NotificationsService';
import CustomerService from './customers/services/CustomerService';
import ProjectBaseService from './projects/base/service/ProjectBaseService';
import ProjectGroupService from './projects/groups/service/ProjectGroupService';
import ProjectNamespaceService from './projects/groups/service/ProjectNamespaceService';
import ProjectQueueTaskService from './projects/groups/service/ProjectQueueTaskService';
import SettingColorService from './projects/groups/service/SettingColorService';
import SettingIconService from './projects/groups/service/SettingIconService';
import NamespaceAdminRoleService from './projects/performers/i-service/NamespaceAdminRoleService';
import EmployeeService from './projects/performers/service/EmployeeService';
import PerformersListService from './projects/performers/service/PerformersListService';
import PerformersSaveService from './projects/performers/service/PerformersSaveService';
import PerfromersService from './projects/performers/service/PerfromersService';
import ProjectAdminRoleService from './projects/performers/service/ProjectAdminRoleService';
import SettingsService from './settings/service/SettingsService';
import ProjectSprintService from './projects/sprints/services/ProjectSprintService';
import ProjectSprintStatusServices from './projects/sprints/services/ProjectSprintStatusServices';
import ProjectTaskGetService from './projects/task/service/ProjectTaskGetService';
import ProjectTaskSaveService from './projects/task/service/ProjectTaskSaveService';
import TaskTagService from './projects/task/service/TaskTagService';
import TaskDifficultyListService from './projects/task/service/TaskDifficultyListService';
import TaskFilterServices from './projects/task/service/TaskFilterServices';
import TaskObserverService from './projects/task/service/TaskObserverService';
import TaskPriorityGetService from './projects/task/service/TaskPriorityGetService';
import TaskPrioritySaveService from './projects/task/service/TaskPrioritySaveService';
import TaskService from './projects/task/service/TaskService';
import TaskStatusListService from './projects/task/service/TaskStatusListService';
import TaskStatusSaveService from './projects/task/service/TaskStatusSaveService';
import TaskTypeListService from './projects/task/service/TaskTypeListService';
import TaskTypeSaveService from './projects/task/service/TaskTypeSaveService';
import TaskTimersService from './projects/task-timer/service/TaskTimersService';
import TaskCommentService from './projects/task-comments/service/TaskCommentService';
import TransactionService from './transactions/service/TransactionService';
import UsersService from './users/base/service/UsersService';
import UsersProfileService from './users/profile/service/UsersProfileService';
import WorkingCalendarService from './working-calendar/service/WorkingCalendarService';
import FavouriteService from './projects/favourite/service/FavouriteService';
import ServiceClickUpRestApi from './projects/click-up-api/service/ServiceClickUpRestApi';
import TestHubManagerService from './projects/autotest/service/test-hub/TestHubManagerService';
import TestHubPoolService from './projects/autotest/service/test-hub/TestHubPoolService';
import TestHubEventTracert from './projects/autotest/service/test-hub/events/TestHubEventTracert';
import ScenarioMangerService from './projects/autotest/service/scenario-manager/ScenarioMangerService';
import ServiceClickUpRestApiPM from './projects/click-up-api/p-m/service/ServiceClickUpRestApiPM';
import NotificationService from './firebase/NotificationService';
import StatisticProjectService from './statistic/service/StatisticProjectService'

export default class apiDataSourceMain {
	FileS3Service: FileS3Service;
	LogsAnalysisService: LogsAnalysisService;
	ServiceTelegramApi: ServiceTelegramApi;
	NotificationsService: NotificationsService;
	CustomerService: CustomerService;
	ProjectBaseService: ProjectBaseService;
	ProjectGroupService: ProjectGroupService;
	ProjectNamespaceService: ProjectNamespaceService;
	ProjectQueueTaskService: ProjectQueueTaskService;
	SettingColorService: SettingColorService;
	SettingIconService: SettingIconService;
	NamespaceAdminRoleService: NamespaceAdminRoleService;
	EmployeeService: EmployeeService;
	PerformersListService: PerformersListService;
	PerformersSaveService: PerformersSaveService;
	PerfromersService: PerfromersService;
	ProjectAdminRoleService: ProjectAdminRoleService;
	SettingsService: SettingsService;
	ProjectSprintService: ProjectSprintService;
	ProjectSprintStatusServices: ProjectSprintStatusServices;
	ProjectTaskGetService: ProjectTaskGetService;
	ProjectTaskSaveService: ProjectTaskSaveService;
	TaskTagService: TaskTagService;
	TaskDifficultyListService: TaskDifficultyListService;
	TaskFilterServices: TaskFilterServices;
	TaskObserverService: TaskObserverService;
	TaskPriorityGetService: TaskPriorityGetService;
	TaskPrioritySaveService: TaskPrioritySaveService;
	TaskService: TaskService;
	TaskStatusListService: TaskStatusListService;
	TaskStatusSaveService: TaskStatusSaveService;
	TaskTypeListService: TaskTypeListService;
	TaskTypeSaveService: TaskTypeSaveService;
	TaskTimersService: TaskTimersService;
	TaskCommentService: TaskCommentService;
	TransactionService: TransactionService;
	UsersService: UsersService;
	UsersProfileService: UsersProfileService;
	WorkingCalendarService: WorkingCalendarService;
	FavouriteService: FavouriteService;
	ServiceClickUpRestApi: ServiceClickUpRestApi;
	TestHubManagerService: TestHubManagerService;
	TestHubPoolService: TestHubPoolService;
	TestHubEventTracert: TestHubEventTracert;
	ScenarioMangerService: ScenarioMangerService;
	ServiceClickUpRestApiPM: ServiceClickUpRestApiPM;
	NotificationService: NotificationService;
	StatisticProjectService: StatisticProjectService;
	constructor(cookieName?: string) {
		this.FileS3Service = new FileS3Service(undefined, cookieName, "appWebSettings.json", "apiUrl");
		this.LogsAnalysisService = new LogsAnalysisService(undefined, cookieName, "appWebSettings.json", "apiUrl");
		this.ServiceTelegramApi = new ServiceTelegramApi(undefined, cookieName, "appWebSettings.json", "apiUrl");
		this.NotificationsService = new NotificationsService(undefined, cookieName, "appWebSettings.json", "apiUrl");
		this.CustomerService = new CustomerService(undefined, cookieName, "appWebSettings.json", "apiUrl");
		this.ProjectBaseService = new ProjectBaseService(undefined, cookieName, "appWebSettings.json", "apiUrl");
		this.ProjectGroupService = new ProjectGroupService(undefined, cookieName, "appWebSettings.json", "apiUrl");
		this.ProjectNamespaceService = new ProjectNamespaceService(undefined, cookieName, "appWebSettings.json", "apiUrl");
		this.ProjectQueueTaskService = new ProjectQueueTaskService(undefined, cookieName, "appWebSettings.json", "apiUrl");
		this.SettingColorService = new SettingColorService(undefined, cookieName, "appWebSettings.json", "apiUrl");
		this.SettingIconService = new SettingIconService(undefined, cookieName, "appWebSettings.json", "apiUrl");
		this.NamespaceAdminRoleService = new NamespaceAdminRoleService(undefined, cookieName, "appWebSettings.json", "apiUrl");
		this.EmployeeService = new EmployeeService(undefined, cookieName, "appWebSettings.json", "apiUrl");
		this.PerformersListService = new PerformersListService(undefined, cookieName, "appWebSettings.json", "apiUrl");
		this.PerformersSaveService = new PerformersSaveService(undefined, cookieName, "appWebSettings.json", "apiUrl");
		this.PerfromersService = new PerfromersService(undefined, cookieName, "appWebSettings.json", "apiUrl");
		this.ProjectAdminRoleService = new ProjectAdminRoleService(undefined, cookieName, "appWebSettings.json", "apiUrl");
		this.SettingsService = new SettingsService(undefined, cookieName, "appWebSettings.json", "apiUrl");
		this.ProjectSprintService = new ProjectSprintService(undefined, cookieName, "appWebSettings.json", "apiUrl");
		this.ProjectSprintStatusServices = new ProjectSprintStatusServices(undefined, cookieName, "appWebSettings.json", "apiUrl");
		this.ProjectTaskGetService = new ProjectTaskGetService(undefined, cookieName, "appWebSettings.json", "apiUrl");
		this.ProjectTaskSaveService = new ProjectTaskSaveService(undefined, cookieName, "appWebSettings.json", "apiUrl");
		this.TaskTagService = new TaskTagService(undefined, cookieName, "appWebSettings.json", "apiUrl");
		this.TaskDifficultyListService = new TaskDifficultyListService(undefined, cookieName, "appWebSettings.json", "apiUrl");
		this.TaskFilterServices = new TaskFilterServices(undefined, cookieName, "appWebSettings.json", "apiUrl");
		this.TaskObserverService = new TaskObserverService(undefined, cookieName, "appWebSettings.json", "apiUrl");
		this.TaskPriorityGetService = new TaskPriorityGetService(undefined, cookieName, "appWebSettings.json", "apiUrl");
		this.TaskPrioritySaveService = new TaskPrioritySaveService(undefined, cookieName, "appWebSettings.json", "apiUrl");
		this.TaskService = new TaskService(undefined, cookieName, "appWebSettings.json", "apiUrl");
		this.TaskStatusListService = new TaskStatusListService(undefined, cookieName, "appWebSettings.json", "apiUrl");
		this.TaskStatusSaveService = new TaskStatusSaveService(undefined, cookieName, "appWebSettings.json", "apiUrl");
		this.TaskTypeListService = new TaskTypeListService(undefined, cookieName, "appWebSettings.json", "apiUrl");
		this.TaskTypeSaveService = new TaskTypeSaveService(undefined, cookieName, "appWebSettings.json", "apiUrl");
		this.TaskTimersService = new TaskTimersService(undefined, cookieName, "appWebSettings.json", "apiUrl");
		this.TaskCommentService = new TaskCommentService(undefined, cookieName, "appWebSettings.json", "apiUrl");
		this.TransactionService = new TransactionService(undefined, cookieName, "appWebSettings.json", "apiUrl");
		this.UsersService = new UsersService(undefined, cookieName, "appWebSettings.json", "apiUrl");
		this.UsersProfileService = new UsersProfileService(undefined, cookieName, "appWebSettings.json", "apiUrl");
		this.WorkingCalendarService = new WorkingCalendarService(undefined, cookieName, "appWebSettings.json", "apiUrl");
		this.FavouriteService = new FavouriteService(undefined, cookieName, "appWebSettings.json", "apiUrl");
		this.ServiceClickUpRestApi = new ServiceClickUpRestApi(undefined, cookieName, "appWebSettings.json", "apiUrl");
		this.TestHubManagerService = new TestHubManagerService(undefined, cookieName, "appWebSettings.json", "apiUrl");
		this.TestHubPoolService = new TestHubPoolService(undefined, cookieName, "appWebSettings.json", "apiUrl");
		this.TestHubEventTracert = new TestHubEventTracert(undefined, cookieName, "appWebSettings.json", "apiUrl");
		this.ScenarioMangerService = new ScenarioMangerService(undefined, cookieName, "appWebSettings.json", "apiUrl");
		this.ServiceClickUpRestApiPM = new ServiceClickUpRestApiPM(undefined, cookieName, "appWebSettings.json", "apiUrl");
		this.NotificationService = new NotificationService(undefined, cookieName, "appWebSettings.json", "apiUrl");
		this.StatisticProjectService = new StatisticProjectService(undefined, cookieName, "appWebSettings.json", "apiUrl");
	}

}
